<template>
  <div class="copyright">
    <p class="copyright__text">
      Copyright © {{ new Date().getFullYear() }} Advarra, Inc. |
      <a
        class="copyright__link"
        target="_blank"
        :href="'https://app.longboat.com/gateway/privacy?locale=' + locale"
        v-html="$t('c_privacy')"
        ></a
      >
    </p>
  </div>
</template>

<script>
export default {
  props: {
    locale: {
      type: String,
      required: true,
    }
  } ,// ["locale"],
};
</script>

<style lang="scss">
.copyright {
  padding: 16px 16px 8px;

  &__text {
    font-size: 14px;
    margin-bottom:0;
  }

  &__link{
    text-decoration: none;
        color: inherit;
    &:active, &:hover, &:visited{
      color: inherit;
      text-decoration: none;
    }
    &:hover{
      text-decoration: underline;
    }
  }
}

@media only screen and (min-width: 1000px) {
  .copyright {
    text-align:right;
  }
}
</style>